{
  "dirty": false,
  "raw": "27f4aeb9",
  "hash": "27f4aeb9",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "27f4aeb9",
  "semverString": null
}